import {
  ProjectTitleCluster as ProjectTitleClusterView,
  useUpdateProject,
  type ProjectTitleClusterProps,
} from '@heidi/agents';

/**
 * The Work chat page's quarantine door — a barrel, deliberately. Chat's outbound
 * set is shrink-only, so `src/pages/scribe/chat/**` cannot grow a new import edge
 * and only this module is baselined. Admit what the page needs, nothing else.
 */
export { RoutineCreateGuidedChat } from '@/features/workflows/components/RoutineCreateGuidedChat';
export { DiscardQueuedTurnsDialog, WorkChatNotFound } from '@heidi/agents';
export { ProjectChatHeader } from './ProjectChatHeader';
export {
  ProjectRunChatBody,
  type ProvisionalSubmitOutcome,
  type SubmitProjectTurnArgs,
} from './ProjectRunChatBody';
export { ProjectRunRecentRunsRail } from './ProjectRunRecentRunsRail';
// Only the two the app-side host still owns. The run-options control, the
// composer glow and the Auto/Evidence pill are in `@heidi/agents` and the page
// binds them straight off that door — a package import is not a quarantine edge,
// so those four lines dissolved instead of moving.
export { WorkHomeBelowComposer, WorkHomeEmptyState } from './WorkHomeChrome';
/* eslint-disable react-refresh/only-export-components -- a door is a barrel by
   construction; the page cannot import these hooks' own module directly. */
export { useWorkChatContextHydration } from '@heidi/agents';
export { useWorkChatSelection } from '@heidi/agents/data';
export { useQueuedTurnDiscardGuard } from '../turn-command/useQueuedTurnDiscardGuard';
/* eslint-enable react-refresh/only-export-components */

/** The Work title | rename cluster, bound to the app's rename mutation. */
export const ProjectTitleCluster = (props: ProjectTitleClusterProps) => (
  <ProjectTitleClusterView {...props} useUpdateProject={useUpdateProject} />
);
